module.exports = __webpack_public_path__ + "img/icon_top_gn.98bcc4d8.svg";